import { colors } from 'css/constants';

const TabStyles = `
.nav-tabs li {
    margin-right: 5px;
}

.nav-tabs .nav-link {
    border-color: ${colors.midGrey};
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    color: ${colors.midGrey};
    min-width: 8em;
}

.nav-tabs .nav-link.active {
    border-color: ${colors.blue};
    border-bottom: 1px solid #fff;
    box-shadow: 0px -1px 5px ${colors.blue}8f, inset 0px 2px 5px ${colors.blue}30;
    color: ${colors.blue};
    position: relative;
}

.nav-tabs .nav-link.active::before {
    background: #fff;
    bottom: -4px;
    content: "";
    height: 5px;
    left: 0px;
    min-width: 100%;
    position: absolute;
}

.nav-tabs .nav-link.active::after {
    background: #fff;
    bottom: -6px;
    content: "";
    height: 5px;
    left: -3px;
    min-width: calc(100% + 6px);
    position: absolute;
}

.tab-content {
    height:calc(100% - 50px);
    margin-top: 10px;
    overflow: auto;
}
`;

export default TabStyles;
